export const Configuration = {
  API_URL: process.env.REACT_APP_API_URL ?? '',
};

export const MFA_REFRESH_IN_SECONDS = 60;

export const sessionExpired = 'Session expired';

export const invalidToken = 'Invalid access token';

export const userSessionExpired = 'Your session has expired';

export const EXPIRE_COOKIES_IN_MS = 3600 * 1000;

export const DecryptionType = {
  overlay: 'OVERLAY',
  popUp: 'POPUP',
};

export const LayoutType = {
  input: 'input',
  success: 'success',
};

export const AccountStatus = {
  active: 'Active',
  inActive: 'Inactive',
  activeCaps: 'ACTIVE',
};

export const DateFormat = 'MM/DD/YYYY';
export const NotificationType = {
  support: 'SUPPORT',
  recovery: 'RECOVERY',
};

export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const SEARCH_DEBOUNCE_TIME = 500;

export const SESSION_EXPIRE_TOAST_TIME = 30 * 1000;

export const ERR_NETWORK = {
  code: 'ERR_NETWORK',
  message: 'Internet connection unstable',
};

export const MAX_UPLOAD_FILE_SIZE = 10 ** 7; // 10,000,000, or 10MB

export const burnedTimeThreshold = '3 mins';
